import cpSite from './_webpack/cpSite.js'

window.cpSite = cpSite

// integrate(). Стартует до загрузки DOM
cpSite.onstart()

// activate(). Начало работы после полной загрузки DOM
window.addEventListener('load', function () {
  cpSite.onload()
})
